import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";

const SECTIONS = [
  {
    title: "Information We Collect",
    body: [
      "When you submit a form on this website, we collect the information you provide: your name, phone number, email address, state, ZIP code, and general information about the coverage you are seeking. If you choose to answer preliminary health questions, those high-level answers are stored with your request and shared only as needed to help you obtain a quote.",
      "We do not collect Social Security numbers, banking details, or medical records through this website.",
      "We also collect basic technical information (such as pages visited and general referral data) to understand how the site is used. Health answers and personal form values are never sent to analytics tools.",
    ],
  },
  {
    title: "How We Use Your Information",
    body: [
      "We use the information you submit to contact you about life insurance products, prepare quote comparisons, and respond to your questions. We do not sell your personal information.",
    ],
  },
  {
    title: "Who We Share It With",
    body: [
      "Your information may be shared with insurance carriers only as needed to provide quotes or process an application you choose to submit. We may also use service providers (such as email delivery services) that process information on our behalf under appropriate safeguards.",
    ],
  },
  {
    title: "How Long We Keep It",
    body: [
      "Lead information is retained for up to 24 months after your last interaction with us, unless a longer period is required for an active policy or by law. You may request earlier deletion at any time.",
    ],
  },
  {
    title: "Your Choices and Rights",
    body: [
      "You may request a copy of the information you submitted, ask us to correct it, or ask us to delete it. To make a request, contact us using the information below. We will respond within a reasonable timeframe.",
      "Depending on your state, you may have additional rights under state privacy laws.",
    ],
  },
  {
    title: "Do Not Sell or Share My Personal Information",
    id: "do-not-sell",
    body: [
      "1907 Insurance Group does not sell personal information, and we do not share it for cross-context behavioral advertising. If you would like to confirm or exercise any privacy right, call (877) 833-1907 or submit a request through the contact form on this website.",
    ],
  },
  {
    title: "Security",
    body: [
      "We use reasonable administrative and technical safeguards to protect submitted information, including encrypted transmission and restricted access. No website can guarantee absolute security.",
    ],
  },
  {
    title: "Changes to This Policy",
    body: [
      "We may update this policy from time to time. The current version will always be posted on this page with its effective date.",
    ],
  },
];

export default function Privacy() {
  return (
    <>
      <SEO title="Privacy Policy | 1907 Insurance Group" description="How 1907 Insurance Group collects, uses, and protects your information." />
      <PageHero eyebrow="Privacy Policy" title="Your Information, Handled With Care"
        intro="Draft pending legal review. This policy explains what we collect, why, and the choices you have. Effective date: [TO BE SET AT LAUNCH]." />
      <section className="py-16 md:py-24" data-testid="privacy-content">
        <div className="container-site max-w-3xl space-y-12">
          {SECTIONS.map((s) => (
            <Reveal key={s.title}>
              <section id={s.id} aria-label={s.title}>
                <h2 className="text-2xl tracking-tight">{s.title}</h2>
                {s.body.map((p, i) => <p key={i} className="mt-4 text-lg text-mutedink leading-relaxed">{p}</p>)}
              </section>
            </Reveal>
          ))}
          <Reveal>
            <p className="text-lg text-mutedink leading-relaxed">
              Questions? Call Michael Janas at{" "}
              <a href="tel:+18778331907" className="text-navy underline">(877) 833-1907</a> or use the contact form on this website.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
